<template>
  <v-app class="admin-login-app">
    <v-main>
      <v-container fluid fill-height class="admin-login-container pa-4">
        <v-row align="center" justify="center" class="ma-0 fill-height">
          <v-col cols="12" sm="9" md="6" lg="4" xl="3" class="pa-0">
            <v-card class="admin-login-card" elevation="10">
              <div class="login-card-header">
                <div class="login-brand-mark">{{ platformInitial }}</div>
                <div>
                  <div class="login-brand-name">{{ platformName }}</div>
                  <div class="login-brand-subtitle">Panel de administración</div>
                </div>
              </div>

              <v-card-text class="login-card-body">
                <h1 class="login-title">Bienvenido</h1>
                <p class="login-description">Ingresá con tus credenciales para administrar el sitio.</p>

                <v-alert v-if="errorMessage" type="error" text dense class="mb-5">
                  {{ errorMessage }}
                </v-alert>

                <form @submit.prevent="funIngresar">
                  <v-text-field
                    v-model.trim="usuario.email"
                    type="email"
                    label="Correo electrónico"
                    prepend-inner-icon="mdi-email-outline"
                    autocomplete="username"
                    outlined
                    dense
                    class="mb-2"
                  />

                  <v-text-field
                    v-model="usuario.password"
                    :type="showPassword ? 'text' : 'password'"
                    label="Contraseña"
                    prepend-inner-icon="mdi-lock-outline"
                    :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                    autocomplete="current-password"
                    outlined
                    dense
                    @click:append="showPassword = !showPassword"
                  />

                  <div class="login-actions-row">
                    <button type="button" class="forgot-link" @click="recuperarPassword">
                      ¿Olvidaste tu contraseña?
                    </button>
                  </div>

                  <v-btn
                    type="submit"
                    block
                    dark
                    color="#171717"
                    height="46"
                    class="login-submit"
                    :loading="ingresando"
                  >
                    Ingresar
                  </v-btn>
                </form>
              </v-card-text>

              <div class="login-footer">Acceso al panel interno</div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import authService from './../../service/AuthService';
import ability from '../../casl/ability';
import { loadRuntimeContext } from '@/tenancy/runtimeContext';

export default {
  name: 'LoginView',

  data() {
    return {
      checkbox: false,
      usuario: { email: 'supervisor@mail.com', password: 'admin4321' },
      errores: {},
      errorMessage: '',
      ingresando: false,
      showPassword: false,
      platformName: '',
      runtimeScope: '',
    };
  },

  computed: {
    platformInitial() {
      return this.platformName.trim().charAt(0).toUpperCase() || 'A';
    },
  },

  mounted() {
    loadRuntimeContext().then((context) => {
      this.runtimeScope = context.scope || '';
      this.platformName = context.platform?.name || '';
    }).catch(() => {});
  },

  methods: {
    recuperarPassword() {
      this.$router.push('/recuperar-password');
    },

    async funIngresar() {
      this.errores = {};
      this.errorMessage = '';
      this.ingresando = true;

      try {
        const { data } = await authService.login(this.usuario);

        data.user.permisos.push({ action: 'show', subject: 'auth' });

        localStorage.setItem('token', data.access_token);
        localStorage.setItem('permisos', JSON.stringify(data.user.permisos));
        localStorage.setItem('userData', JSON.stringify(data.user));
        if (data.tenant?.slug) {
          localStorage.setItem('active_tenant_slug', data.tenant.slug);
        } else {
          localStorage.removeItem('active_tenant_slug');
        }

        ability.update(data.user.permisos);
        this.$router.push(data.user.is_platform_admin && this.runtimeScope === 'platform'
          ? { name: 'empresas-plataforma' }
          : { name: 'perfil' });
      } catch (error) {
        const response = error && error.response ? error.response : null;
        const responseData = response ? response.data : null;

        if (response && response.status === 401) {
          this.errorMessage = 'El correo o la contraseña son incorrectos.';
        } else if (response && response.status === 422 && responseData && responseData.errors) {
          this.errores = responseData.errors;
          this.errorMessage = 'Revisá los datos ingresados.';
        } else {
          this.errorMessage = 'No se pudo iniciar sesión. Intentá nuevamente.';
        }
      } finally {
        this.ingresando = false;
      }
    },

    async loginGoogle() {
      const { data } = await authService.loginConGoogleURL();
      if (data.url) window.location.href = data.url;
    },
  },
};
</script>

<style scoped>
.admin-login-app {
  background: #eeeeee !important;
  text-align: left;
}

.admin-login-container {
  min-height: 100vh;
  background:
    radial-gradient(circle at 15% 20%, rgba(0, 0, 0, .045), transparent 27%),
    linear-gradient(135deg, #f8f8f8 0%, #e8e8e8 100%);
}

.admin-login-card {
  overflow: hidden;
  border-radius: 18px !important;
  border: 1px solid #dedede;
  background: #ffffff;
}

.login-card-header {
  min-height: 92px;
  padding: 22px 26px;
  display: flex;
  align-items: center;
  gap: 13px;
  background: #151515;
}

.login-brand-mark {
  width: 43px;
  height: 43px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #ffffff;
  color: #111111;
  font-size: 1.2rem;
  font-weight: 900;
}

.login-brand-name {
  color: #ffffff;
  font-size: 1.05rem;
  font-weight: 800;
}

.login-brand-subtitle {
  color: #9c9c9c;
  font-size: .76rem;
  margin-top: 2px;
}

.login-card-body {
  padding: 30px 28px 24px !important;
}

.login-title {
  margin: 0 0 5px;
  color: #171717;
  font-size: 1.55rem;
  font-weight: 800;
}

.login-description {
  margin: 0 0 25px;
  color: #777777;
  font-size: .88rem;
  line-height: 1.45;
}

.login-actions-row {
  display: flex;
  justify-content: flex-end;
  margin: -2px 0 20px;
}

.forgot-link {
  padding: 0;
  border: 0;
  background: none;
  color: #4c4c4c;
  font-size: .8rem;
  cursor: pointer;
}

.forgot-link:hover {
  color: #000000;
  text-decoration: underline;
}

.login-submit {
  border-radius: 9px !important;
  text-transform: none !important;
  font-weight: 700;
  letter-spacing: .01em !important;
}

.login-footer {
  padding: 13px 20px;
  border-top: 1px solid #ededed;
  color: #999999;
  background: #fafafa;
  text-align: center;
  font-size: .72rem;
}

@media (max-width: 600px) {
  .admin-login-container {
    padding: 14px !important;
  }

  .admin-login-card {
    border-radius: 14px !important;
  }

  .login-card-header {
    padding: 19px 20px;
  }

  .login-card-body {
    padding: 24px 20px 20px !important;
  }
}
</style>
